import { AlertTriangle, Clock } from "lucide-react";
import type { NicheDataStatus } from "@/lib/nicheData";

function fmt(iso: string | null) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric", timeZone: "UTC" });
}

/** Rendered only when the page is NOT serving fresh data, so visitors and crawlers see an honest date. */
export default function DataFreshnessNotice({ status, asOf }: { status: NicheDataStatus; asOf: string | null }) {
  if (status === "live" || status === "empty") return null;
  if (status === "stale") {
    return (
      <div role="status" className="glass-3d rounded-xl px-4 py-3 flex items-center gap-2 text-sm text-muted-foreground">
        <Clock className="w-4 h-4 text-warning shrink-0" aria-hidden="true" />
        <span>
          Showing the saved snapshot from <strong className="text-foreground">{fmt(asOf) ?? "a recent date"}</strong>.
          Fresh signals are temporarily unavailable and will return automatically.
        </span>
      </div>
    );
  }
  return (
    <div role="alert" className="glass-3d rounded-xl px-4 py-3 flex items-center gap-2 text-sm text-muted-foreground">
      <AlertTriangle className="w-4 h-4 text-destructive shrink-0" aria-hidden="true" />
      <span>Niche data is temporarily unavailable. Please try again in a few minutes.</span>
    </div>
  );
}
